import { render, staticRenderFns } from "./submissions-panel.vue?vue&type=template&id=2b9113d0&scoped=true&"
import script from "./submissions-panel.vue?vue&type=script&lang=ts&"
export * from "./submissions-panel.vue?vue&type=script&lang=ts&"
import style0 from "./submissions-panel.vue?vue&type=style&index=0&id=2b9113d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9113d0",
  null
  
)

export default component.exports